@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@border: 1px solid @batch-list-page--filter-bar--border-color;

.filter-bar-wrapper {
  padding: 10px;
  border: @border;
}
